import { notify } from 'utils/reduxUtils';

export const types = {
  UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_ERROR:
    'settings/digitalQuote/UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_ERROR',
  UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_REQUEST:
    'settings/digitalQuote/UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_REQUEST',
  UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_SUCCESS:
    'settings/digitalQuote/UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_SUCCESS',
};

export const updateSupplierDefaultInternalNotes = {
  error: notify(
    (error) => ({
      type: types.UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_ERROR,
      payload: error,
    }),
    'Failed to update internal notes',
  ),
  request: ({ internalNotes }) => ({
    type: types.UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_REQUEST,
    payload: { internalNotes },
  }),
  success: notify(
    ({ internalNotes }) => ({
      type: types.UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_SUCCESS,
      payload: { internalNotes },
    }),
    'Internal notes successfully updated',
  ),
};
